<div class="alert alert-info">
  <fa-icon icon="info-circle"></fa-icon>
  Le support est accessible :
  <ul>
    <li>aux administrateurs et/ou utilisateurs ayant suivi un transfert de compétences par Libriciel SCOP</li>
    <li>à une personne ayant suivi un transfert de compétences en interne par un utilisateur préalablement formé par
      Libriciel SCOP
    </li>
  </ul>
  Vous pouvez ajouter jusqu'à trois utilisateurs portail par application, en fonction de la taille et des usages de la
  structure.
</div>

<ul [formGroup]="form" ngbNav #nav="ngbNav" class="nav-tabs" [(activeId)]="active" [animation]="false"
    [class.d-none]="enabledProducts.length === 0" [destroyOnHide]="false">
  @for (p of enabledProducts; track p) {
    <li [ngbNavItem]="p.slug">
      <a ngbNavLink [ngClass]="getValidity(p)">
        <fa-icon class="pe-2" icon="times" (click)="removeProduct($event, p)"
                 ngbTooltip="Retirer le logiciel"></fa-icon>
        <span class="show-invalid" ngbTooltip="Il manque des champs obligatoires à renseigner">
        {{ p.name }}
          <fa-icon class="ps-2 pe-2" icon="exclamation-circle"></fa-icon>
      </span>
        <span class="show-valid">
        {{ p.name }}
      </span>
      </a>
      <ng-template ngbNavContent>
        <app-user-product-form [canReplace]="canreplace" [parentForm]="form" [product]="p"></app-user-product-form>
      </ng-template>
    </li>
  }

  <li class="nav-item" [ngbNavItem]="'choice'">
    <a class="nav-link" ngbNavLink>
      <fa-icon class="pe-2" icon="plus-circle"></fa-icon>
      Ajouter
    </a>
    <ng-template ngbNavContent>
      <div class="row">
        @if(tmpForm && active === 'choice') {
          @if(question.options.length > 0) {
            <app-dynamic-form [questions]="[question]" [(form)]="tmpForm"></app-dynamic-form>
          } @else {
            <div class="mb-3">
              <span class="text-danger">Aucune option disponible</span>
            </div>
          }
        }

      </div>
    </ng-template>
  </li>
</ul>

<div [ngbNavOutlet]="nav" class="mt-2"></div>
